// src/aws-config.js
// AWS Amplify configuration to replace Auth0

const awsRegion = import.meta.env.VITE_AWS_REGION || "us-east-1";
const cognitoUserPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const cognitoClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
const cognitoIdentityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID;

// Stripe configuration
const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY || "pk_test_...";

// API configuration
const apiUrl = import.meta.env.VITE_API_URL || "https://stage-api.shieldshot.com";

// Validate required Cognito environment variables
if (!cognitoUserPoolId || !cognitoClientId) {
  console.error('Missing required Cognito environment variables:');
  console.error('VITE_COGNITO_USER_POOL_ID:', cognitoUserPoolId ? '✓' : '✗ Missing');
  console.error('VITE_COGNITO_CLIENT_ID:', cognitoClientId ? '✓' : '✗ Missing');
  console.error('VITE_COGNITO_IDENTITY_POOL_ID:', cognitoIdentityPoolId ? '✓' : '✗ Missing (optional)');
}

console.log('AWS Configuration loaded:', {
  awsRegion,
  cognitoUserPoolId: cognitoUserPoolId ? `${cognitoUserPoolId.substring(0, 10)}...` : 'Missing',
  cognitoClientId: cognitoClientId ? `${cognitoClientId.substring(0, 10)}...` : 'Missing',
  cognitoIdentityPoolId: cognitoIdentityPoolId || 'Missing',
  apiUrl
});

// Determine environment (stage or prod) based on apiUrl or env
const isStage = apiUrl.includes('stage') || import.meta.env.MODE === 'development' || import.meta.env.VITE_STAGE === 'stage';
const bucketSuffix = isStage ? '-stage' : '';

const s3Buckets = {
  uploads: `shieldshot-uploads${bucketSuffix}`,
  temp: `shieldshot-temp${bucketSuffix}`,
  avatars: `shieldshot-avatars${bucketSuffix}`,
  public: `shieldshot-public${bucketSuffix}`
};

const amplifyConfig = {
  Auth: {
    region: awsRegion,
    userPoolId: cognitoUserPoolId,
    identityPoolId: cognitoIdentityPoolId,
    Cognito: {
      region: awsRegion,
      userPoolId: cognitoUserPoolId,
      userPoolClientId: cognitoClientId,
      signUpVerificationMethod: 'code', // Use email verification codes
      loginWith: {
        email: true,
        oauth: {
          domain: 'shieldshot.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [
            'http://localhost:3000/',
            'https://staging.shieldshot.com/',
            'https://www.shieldshot.com/'
          ],
          redirectSignOut: [
            'http://localhost:3000/',
            'https://staging.shieldshot.com/',
            'https://www.shieldshot.com/'
          ],
          responseType: 'code'
        }
      }
    }
  }
  // Remove Storage config entirely - we'll handle S3 manually with Identity Pool
};

export default {
  amplifyConfig,
  awsRegion,
  cognitoUserPoolId,
  cognitoClientId,
  cognitoIdentityPoolId,
  stripePublicKey,
  apiUrl,
  s3Buckets,
};
